<template>
  <div class="modal-container">
    <div class="wraper-content">
      <div class="wraper-title">
        <h1 class="header">
          Chose New Password
        </h1>
        <h3 class="text-modal">
          Enter the new password for your account
        </h3>
      </div>
      <form class="form-input" @submit.prevent="formSubmit">
        <HeraFormPasswordInput
          v-model.trim="password"
          v-validate="$options.passwordValidationRule"
          name="password"
          type="password"
          :tabindex="1"
          :autofocus="true"
          label="New Password"
          :error="errors.first('password')"
        />
        <HeraFormSubmitBtn
          id="submitPassword"
          :tabindex="2"
          :label="$t('web_submitpassword_submit_button', 'Submit Password')"
          class="new-signup-btn"
        />
        <button
          :tabindex="3"
          class="new-signup-btn back-signin"
          @click="openSignInModal"
        >
          Back to sign in
        </button>
      </form>
    </div>
    <ModalBackdrop
      v-model="isLoading"
      class="submit-password-loader"
      :style="{ width: `100%` }"
      :click_on_backdrop="false"
      :esc_key="false"
      :variant="'loader'"
    >
      <img
        src="~@/assets/images/playhera-indo/Playhera_Loader.svg"
        alt="Loader"
      />
    </ModalBackdrop>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import { password as passwordValidationRule } from '@/constants/validationRules';
import HeraFormPasswordInput from '@/components/form/NewInputPassword';
import HeraFormSubmitBtn from '@/components/form/HeraFormSubmitBtn';
import ModalBackdrop from '@/components/common/ModalBackdrop.vue';

import isLoading from '@/mixins/isLoading.js';

export default {
  name: 'SubmitPassword',
  inject: ['$validator'],
  components: {
    HeraFormPasswordInput,
    HeraFormSubmitBtn,
    ModalBackdrop,
  },
  mixins: [isLoading],
  data() {
    return {
      password: null,
      isLoading: false,
      isPasswordChanged: false,
    };
  },
  created() {
    this.$options.passwordValidationRule = passwordValidationRule;
  },
  destroyed() {
    this.clearAllTokens();
  },
  methods: {
    ...mapActions(['clearAllTokens', 'closeModal', 'openModal']),
    ...mapActions({
      sendRequest: 'submitPass',
      errorNotify: 'errorNotify',
    }),
    openSignInModal() {
      this.openModal({
        name: 'SignInModal',
        settings: {
          clickOnBackdrop: false,
          escKey: false,
          variant: 'transparent',
        },
      });
    },
    formSubmit() {
      this.isLoading = true;
      this.$validator
        .validateAll()
        .then(
          result =>
            result
              ? Promise.resolve({ password: this.password })
              : Promise.reject() // eslint-disable-line
        )
        .then(this.sendRequest)
        .then(() => {
          this.isPasswordChanged = true;
        })
        .catch(codeError => {
          this.isLoading = false;
          if (
            !codeError.skipNext &&
            typeof codeError.skipNext !== 'undefined'
          ) {
            this.errorNotify(
              this.$t(
                '_web_common-error',
                'Something went wrong. Please try again later'
              )
            );
          }
        })

        .then(() => {
          setTimeout(() => {
            this.isLoading = false;

            this.openModal({
              name: 'SignUpModal',
              settings: {
                clickOnBackdrop: false,
                escKey: false,
                variant: 'transparent',
              },
            });
          }, 1500);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.modal-container {
  border-radius: 16px;
  background: #151520 !important;
  max-height: 650px;
  flex-direction: column;
  align-items: center;
  min-height: 60dvh;
  max-height: 90dvh;
  display: flex;
  gap: 32px;
  flex-direction: column;
  justify-content: center;
  font-family: 'Alexandria', sans-serif;
  max-width: 625px;

  min-width: 625px;
  @media (max-width: 915px) {
    max-width: 525px;
    min-width: 525px;
  }
  @media (max-width: 600px) {
    max-width: 455px;
    min-width: 455px;
  }
  @media (max-width: 450px) {
    max-width: 325px;
    min-width: 325px;
    overflow-y: auto;
  }
  @media (max-height: 600px) {
    overflow-y: scroll;
    justify-content: flex-start;
  }
  > .wraper-content {
    border-radius: 16px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    gap: 32px;
    height: 100%;
    min-height: 450px;
    padding: 40px 32px;
    @media (max-width: 600px) {
      padding: 40px 20px;
    }
    > .wraper-title {
      display: flex;
      flex-direction: column;
      gap: 4px;

      > .header {
        margin: 0 !important;
        font-size: 32px;
        font-style: normal;
        font-weight: 600;
        line-height: 135%; /* 43.2px */
        letter-spacing: -0.48px;
        background: var(
          --Title,
          linear-gradient(
            90deg,
            rgba(255, 255, 255, 0.5) 5.29%,
            rgba(255, 255, 255, 0.91) 51.55%,
            rgba(255, 255, 255, 0.5) 100%
          )
        );
        background-clip: content-box;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      > .text-modal {
        margin: 0 !important;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        color: rgba(255, 255, 255, 0.5);
        text-align: center;
        > a {
          color: var(--opacity-700, rgba(255, 255, 255, 0.8));
          cursor: pointer;
          &:hover {
            color: #5a58f2;
          }
        }
      }
    }
    > form.form-input {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 16px;
      align-self: stretch;
      width: 100%;

      > .new-signup-btn {
        background-color: white !important;
        display: flex;
        padding: 16px;
        justify-content: center;
        align-items: center;
        gap: 12px;
        align-self: stretch;
        color: #121217 !important;
        text-align: center;
        /* Body/Body-16/Medium */
        font-family: 'Alexandria';
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
        margin-top: 10px;
      }
      > .back-signin {
        background-color: black !important;

        color: white !important;
      }
    }
  }
  .submit-password-loader {
    width: 100vw !important;
    > .modalbackdrop_container {
      background: none !important;
      background-color: transparent !important;
    }
  }
}
</style>
